import { createApp } from "vue";
import App from "./App.vue";
import "./assets/css/custom.scss";
import "./assets/css/media.scss";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import "./assets/js/custom.js";
import axios from "axios";
import router from "./router";
import store from "./store";
axios.defaults.baseURL = "https://backend.qiyas.co/api";
// axios.defaults.baseURL = "http://127.0.0.1:8000/api";

const app = createApp(App).use(store).use(router);
app.mount("#app");

// "homepage": "https://github.com/Taha-Abdelmonim/e-commerce/",
